import { ModelImage } from "./ModelImage";
import { PostalAddress } from "./PostalAddress";

export class Customer extends ModelImage {
  id;
  licenseId = '';
  companyName = '';
  contactBirthdate = '';
  contactEmail = '';
  password = '';
  contactGender = '';
  contactName = '';
  contactPhone1 = '';
  contactPhone2 = '';
  contactSurname = '';
  customFieldValues = [];
  customerFiles = [];
  customerLegalDocuments = [];
  postalAddress = new PostalAddress();
  status = '';
  vat = '';
  notes = '';
  // New statistical fields
  statsCountryCode = '';
  statsPostalCode = '';
  statsHowMet = '';
  statsHowMetOther = '';

  constructor(data){
    if(data instanceof Customer){
      return data
    }
    super();
    if(!data){
      return;
    }
    let mappableFields = ['id', 'customFieldValues', 'licenseId', 'companyName', 'contactBirthdate', 'contactEmail', 'password', 'contactGender', 'contactName', 'contactPhone1', 'contactPhone2', 'contactSurname', 'status', 'vat', 'notes', 'statsCountryCode', 'statsPostalCode', 'statsHowMet', 'statsHowMetOther'];
    this.mapFields(data, mappableFields);
    this.mapImageFile(data);
    this.mapPostalAddress(data);
    // Mantener el teléfono completo con prefijo para compatibilidad
    this.contactPhone1 = this.contactPhone1 || '';
  }

  mapPostalAddress(data){
    if(data.postalAddress) {
      this.postalAddress = new PostalAddress(data.postalAddress);
    }
  }

  getApiData() {
    const clone = JSON.parse(JSON.stringify(this));
    delete clone.postalAddress
    // Ya no necesitamos añadir el prefijo aquí porque PhoneSelector lo maneja
    return clone
  }

}
